import { InjectionToken } from "@angular/core";
import { IWidgetVersionRestClient } from "./i-widget-version-rest.client";

export const widgetVersionRestClientInjectionToken: InjectionToken<IWidgetVersionRestClient> = new InjectionToken<IWidgetVersionRestClient>( "digital-signage.developer-dashboard.dashboard-web.WidgetVersionRestClient" );
